import { ConsentSignatureResultModel, FileResultModel, QuestionResultModel, ResultModel } from "../types/SurveyResult";

export function hasAnswer(result: ResultModel | undefined): boolean {
    if (!result) return false;

    if ("Answers" in result) {
        const questionResult = result as QuestionResultModel;
        return !!questionResult.Answers.find((answer: string) => !!answer);
    }

    if ("FileName" in result) {
        const fileResult = result as FileResultModel;
        return !!fileResult.FileName;
    }

    if ("Signature" in result) {
        const consentSignatureResult = result as ConsentSignatureResultModel;
        return !!consentSignatureResult.Signature &&
            (!!consentSignatureResult.Signature.FamilyName ||
                !!consentSignatureResult.Signature.GivenName ||
                !!consentSignatureResult.Signature.HandwrittenSignatureBase64);
    }

    return false;
}